/**
 * @flow
 */
export const CALL_LOADING = 'CALL_LOADING';